import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { MatDialog } from '@angular/material';
import { AirportService } from '../airport.service';
import { AdminAirportComponent } from '../admin-airport/admin-airport.component';
var AirportFlightDeckButtonComponent = /** @class */ (function () {
    function AirportFlightDeckButtonComponent(_airportFlightDeckAdminDialog, _airportService) {
        this._airportFlightDeckAdminDialog = _airportFlightDeckAdminDialog;
        this._airportService = _airportService;
        this.airportChange = new EventEmitter();
    }
    AirportFlightDeckButtonComponent.prototype.ngOnInit = function () {
    };
    AirportFlightDeckButtonComponent.prototype.flightDeckBusinessTools = function () {
        var _this = this;
        var dialogRef = this._airportFlightDeckAdminDialog.open(AdminAirportComponent, {
            disableClose: false,
            autoFocus: true,
            width: '50%',
            data: {
                airport: this.airport
            }
        });
        dialogRef.afterClosed().subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.airportId.toString(), true)];
                    case 1:
                        _a.airport = _b.sent();
                        this.airportChange.emit(this.airport);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return AirportFlightDeckButtonComponent;
}());
export { AirportFlightDeckButtonComponent };
